import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { PAGE_STATUS_CONFIG } from "@/lib/status-configs";
import { MagnifyingGlass } from "@phosphor-icons/react";

export type PageStatusFilter = "" | "published" | "draft";

const STATUS_TABS: { value: PageStatusFilter; label: string }[] = [
  { value: "", label: "Sve" },
  { value: "published", label: "Objavljene" },
  { value: "draft", label: "Nacrti" },
];

export function PageFilterTabs({
  statusFilter,
  searchQuery,
  onStatusChange,
  onSearchChange,
}: {
  statusFilter: PageStatusFilter;
  searchQuery: string;
  onStatusChange: (value: PageStatusFilter) => void;
  onSearchChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex w-full gap-1.5 rounded-xl bg-muted/60 p-1.5 md:w-auto">
        {STATUS_TABS.map((tab) => {
          const isActive = statusFilter === tab.value;
          const config = tab.value
            ? PAGE_STATUS_CONFIG[tab.value as keyof typeof PAGE_STATUS_CONFIG]
            : null;
          return (
            <button
              key={tab.value}
              onClick={() => onStatusChange(tab.value)}
              className={cn(
                "flex flex-1 items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-sm font-medium transition-all duration-200",
                isActive
                  ? "bg-background text-foreground shadow-sm ring-1 ring-border/50"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <span
                className={cn(
                  "size-2 shrink-0 rounded-full transition-colors",
                  isActive && config
                    ? config.dot
                    : isActive
                      ? "bg-foreground/40"
                      : "bg-muted-foreground/30"
                )}
              />
              <span className="truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="relative w-full md:w-72">
        <MagnifyingGlass className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Pretraži stranice..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
}
